// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__RUsgT","pages":"pagination_pages__Wl6Gm"};